import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'optionType' })
export class OptionTypePipe implements PipeTransform {
  transform(type: string): string {
    switch (type?.trim()) {
      case 'TypeOfResearch':
        return 'Type of Research';
      case 'SponsorType':
        return 'Sponsor Type';
      case 'ReviewCycle':
        return 'Review Cycle';
      case 'TypeOfReview':
        return 'Type of Review';
      case 'NTRIRBCoordinator':
        return 'NTRIRB Coordinator';
      case 'FundingAgency':
        return 'Funding Agency';
      case 'NatureOfResearch':
        return 'Nature Of Research';
      case 'SponsoredClinicalTrial':
        return 'Sponsored Clinical Trial (Drug/Device/Biologic)';
      case 'CollaboratingInstitution':
          return 'Collaborating Institution';
      case 'IrbofRecord':
            return 'IRB of Record';
      default:
        return type;
    }
  }
  
}
